var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInfoIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.83325 8.45353C1.83325 4.75656 4.80295 1.78687 8.49992 1.78687C12.1969 1.78687 15.1666 4.75656 15.1666 8.45353C15.1666 12.1505 12.1969 15.1202 8.49992 15.1202C4.80295 15.1202 1.83325 12.1505 1.83325 8.45353ZM3.04537 8.45353C3.04537 11.4838 5.46962 13.9081 8.49992 13.9081C11.5302 13.9081 13.9545 11.4838 13.9545 8.45353C13.9545 5.42323 11.5302 2.99899 8.49992 2.99899C5.46962 2.99899 3.04537 5.42323 3.04537 8.45353ZM8.49992 9.05959C8.86355 9.05959 9.10598 8.81717 9.10598 8.45353V6.02929C9.10598 5.66565 8.86355 5.42323 8.49992 5.42323C8.13628 5.42323 7.89386 5.66565 7.89386 6.02929V8.45353C7.89386 8.81717 8.13628 9.05959 8.49992 9.05959ZM7.89386 10.8778C7.89386 10.5141 8.13628 10.2717 8.49992 10.2717C8.86355 10.2717 9.10598 10.5141 9.10598 10.8778C9.10598 11.2414 8.80295 11.4838 8.49992 11.4838C8.19689 11.4838 7.89386 11.2414 7.89386 10.8778Z",
    fill: "#161D1F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info_icon.ff52e31dd0e6993352ca25073400e05a.svg";
export { ForwardRef as ReactComponent };